import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { MobileBadge } from "@faire/retailer-visitor-shared/icons/AppDownloadBadge/__internal__/MobileBadge";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useLocalization } from "@faire/web--source/common/localization/useLocalization";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { trackRetailerMobileFooterDesktopappStoreBadgeHover } from "@faire/web-api--source/events/retailerMobile/actionUnknown/footerDesktopAppStoreBadgeHover";
import React from "react";
var APP_STORE_QR_IMAGE_URL = "https://cdn.faire.com/fastly/3d77d319b263789c7bf9e0d352daa4d5f80ace5d3a1d46f1d532d4c6b7a13c71.png";
var getBadge = function(locale) {
    if (SUPPORTED_LOCALES.includes(locale)) {
        return "https://cdn.faire.com/static/download-badges/app-store-".concat(locale, ".svg");
    } else {
        return "https://cdn.faire.com/static/download-badges/app-store-en.svg";
    }
};
var useBadgeWidth = function() {
    return useViewport().isDesktopAndAbove && !isLoggedInRetailer() ? 142 : 120;
};
export var AppStoreBadge = function() {
    var badgeWidth = useBadgeWidth();
    return /*#__PURE__*/ _jsx(MobileBadge, {
        backgroundColor: Core.surface.default,
        badge: /*#__PURE__*/ _jsx(AppStoreImage, {}),
        qrCodeUrl: APP_STORE_QR_IMAGE_URL,
        qrCodeContainerWidth: badgeWidth,
        qrCodePadding: 11,
        trackingFunctionOnHover: useViewport().isTabletAndAbove && !isLoggedInRetailer() ? trackRetailerMobileFooterDesktopappStoreBadgeHover : undefined
    });
};
export var AppStoreImage = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var badgeWidth = useBadgeWidth();
    var _useLocalization = useLocalization(), locale = _useLocalization.intl.locale;
    return /*#__PURE__*/ _jsx("img", {
        width: badgeWidth,
        src: getBadge(locale),
        alt: strictLocalize({
            id: "KO8JIn",
            defaultMessage: [
                {
                    type: 0,
                    value: "Apple App Store Badge"
                }
            ]
        }),
        style: {
            display: "block"
        }
    });
};
var SUPPORTED_LOCALES = [
    "ar-AR",
    "az-TR",
    "bg-BG",
    "cs-CZ",
    "da-DK",
    "de-DE",
    "el-GR",
    "en",
    "es-ES",
    "es-MX",
    "et-EE",
    "fi-FI",
    "fr-CA",
    "fr-FR",
    "hb-HB",
    "hu-HU",
    "id-ID",
    "it-IT",
    "ja-JP",
    "ko-KR",
    "lt-LT",
    "lv-LV",
    "ms-MY",
    "mt-MT",
    "nl-NL",
    "no-NO",
    "pl-PL",
    "pt-BR",
    "pt-PT",
    "ro-RO",
    "ru-RU",
    "sk-SK",
    "sl-SI",
    "sv-SE",
    "th-TH",
    "tl-PH",
    "tr-TR",
    "vi-VN",
    "zh-CN",
    "zh-HK"
];
